import React from 'react';
import { colors } from '../constants';

const VideoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
    fill="none"
    className={props.className}
  >
    <rect
      x="2.25"
      y="4.96814"
      width="10.7532"
      height="9.81065"
      rx="1.25"
      stroke={props.color}
      strokeWidth="1.5"
    />
    <path
      d="M13.2237 7.52987L16.3388 5.85292C17.0051 5.49426 17.8129 5.97685 17.8128 6.7335L17.8124 13.2667C17.8124 14.0233 17.0047 14.5058 16.3385 14.1472L13.2234 12.4705"
      stroke={props.color}
      strokeWidth="1.5"
    />
  </svg>
);

VideoIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
};

export default VideoIcon;
